<template>
    <div class="contain">
        <div class="posting-uploader">
            <div
                    @click="videoShow=true;playUrl=item.url"
                    class="posting-uploader-item"
                    v-for="(item, index) in postData"
                    :key="index"
            >
                <van-icon class="play" name="play-circle-o" />
                <img :src="item.url+'?x-oss-process=video/snapshot,t_10,f_jpg,w_0,h_0,m_fast,ar_auto'" class="imgPreview" />
                <van-icon
                        name="close"
                        @click.stop="delImg(index)"
                        class="delte"
                />
            </div>
            <van-uploader
                    :after-read="uploadFile"
                    accept="video/*"
                    v-show=" postData.length < limit"
                    result-type="text"
                    upload-icon="video"
                    upload-text="上传视频"
            >
            </van-uploader>
        </div>
        <van-popup :close-on-click-overlay="false" v-model="showLoading">
            <div class="circle-div"><van-circle :stroke-width="60" :color="{
                                '0%': '#ffad19',
                                '100%': '#fec835',
                              }"  v-model="progress" :rate="progress" :speed="100" :text="progress+'%'" /></div>
            <div> <van-button
                    style="width: 3rem; margin-top: 10px"
                    size="normal" round   @click.stop="cancel">取消上传</van-button>
            </div>

        </van-popup>

        <van-popup v-model="videoShow" >
            <video style="width: 100%" controls="controls" :src="playUrl"  >
            </video>
        </van-popup>
    </div>
</template>

<script>
    import OSS from 'ali-oss';
    import {Uploader, Toast, Loading,Progress,Circle,Dialog } from 'vant';
    import Vue from 'vue';
    import jquery from 'jquery';

    Vue.use(Uploader).use(Toast).use(Loading).use(Progress).use(Circle).use(Dialog);
    var client = {};
    export default {
        props: {
            fileList: Array,
            limit: {
                type: Number,
                default: 0,
            },
            name: {
                type: String,
                default: ''
            },
            fileName: {
                type: String,
                default: ''
            },
            minSize:{
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                postData: [],
                uid: 0,
                playUrl :'',
                progress: 0,
                showLoading: false,
                videoShow: false,
                ossAccessTokenURL: 'https://api.dierqudao.com/core/attachment/aliOssSts',
                ossFileURL: 'https://cheeseman.oss-cn-hangzhou.aliyuncs.com',
            }
        },
        mounted() {
            this.postData = this.fileList;
            let that = this;
            setTimeout(() =>{
                var ua = navigator.userAgent.toLowerCase();
                //判断是否是苹果手机，是则是true
                var isIos = (ua.indexOf('iphone') != -1) || (ua.indexOf('ipad') != -1);
                if (isIos) {
                    jquery("input:file").removeAttr("capture");
                };
                if(!isIos && window.isApp()){
                    jquery('[accept="video/*"]').click((event)=>{
                        console.log('[accept="video/*"]');
                        that.$emit('onInputClick', { });
                        event.stopPropagation();
                        return false;
                    })
//                    jquery("input:file").attr("disabled",'disabled');
                    jquery('[accept="video/*"]').attr("type",'button');
                }


            },500)
        },
        watch: {
            fileList(value) {
                this.postData = value
            },
            progress(value) {
                console.log('progress 变化');
                console.log(value)
            }
        },
        methods: {
            cancel(){
                client.cancel();
                this.showLoading = false;
            },
            delImg(index) {
                // 删除指定下标的图片对象
                let that = this;
                if (isNaN(index) || index >= that.postData.length) {
                    return false
                }

                this.postData.splice(index, 1)
                this.$emit('imageListChange', {'pic': that.postData, 'name': that.name})
            },

            uploadFile(evt) {
                console.log('------uploadFile------')
                let that = this;
                if(this.minSize>0){
                    if((evt.file.size/1024/1024 ) <this.minSize){

                        if(this.minSize==10){
                            Dialog.alert({
                                title: '视频过小',
                                message: '您的视频要求不符合上传要求，建议拍摄高清视频上传，比例16:9，分辨率1280×720（720P 高清）以上',
                            }).then(() => {
                                // on close
                            });
                            return ;
                        }
                    }
                }
                that.showLoading = true;
                OSS.urllib.request(that.ossAccessTokenURL, {method: 'GET'}, function (err, response) {
                    let result;
                    if (err) {
                        Toast.fail('上传异常:' + err);
                        console && console.error(err);
                        return;
                    }

                    try {
                        result = JSON.parse(response);
                    } catch (e) {
                        return alert('parse sts response info error: ' + e.message);
                    }

                    client = new OSS({
                        accessKeyId: result.data.AccessKeyId,
                        accessKeySecret: result.data.AccessKeySecret,
                        stsToken: result.data.SecurityToken,
                        endpoint: result.data.endpoint,
                        bucket: result.data.bucket,
                        secure: true
                    });
                    var suffix = evt.file.name.toLowerCase().split('.').splice(-1)[0];

                    var myDate = new Date().getTime();
                    let time = myDate + '' + (Math.floor(Math.random() * 1000 + 1));
                    let date = that.dateFormat(myDate);

                    var file_save_name = 'h5/video/' + date + '/'+that.fileName+ time + '.' + suffix;
                    client.multipartUpload(file_save_name, evt.file ,{
                        progress:function(p,checkpoint){
                            console.log('----上传进度----')
                            that.progress = parseInt(p*100);
//                            console.log(that.progress);
                            console.log(p)
//                            console.log(p,checkpoint)
                        },

                    }).then(function (result) {
                        console.log(that.ossFileURL);
                        var file = {
                            uid: 'vc-upload-'+time,
                            url: that.ossFileURL + '/' + file_save_name,
                            name: evt.file.name,
                            save_name: file_save_name
                        }
                        that.postData.push(file);

                        that.showLoading = false;
                        // Toast.success(evt.file.name + '上传成功');
                        that.$emit('imageListChange', {'pic': that.postData, 'name': that.name})
                    }).catch(function (err) {
                        // Toast.fail(evt.file.name + '上传失败');
                    })

                })
            },

        }
    }
</script>

<style scoped>
    .contain >>> .van-popup{
        background: none;
    }

    .posting-uploader {
        display: flex;
        flex-wrap: wrap;
    }

    .posting-uploader-item {
        position: relative;
        margin: 0 8px 8px 0;
    }

    .imgPreview {
        /*display: block;*/
        max-width: 80px;
        max-height: 80px;
    }

    .delte {
        /*margin-left: -15px;
        width: 10px;
        height: 10px;
        margin-right: 20px;*/
        position: absolute;
        right: 0;
        top: 0;
        padding: 1px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.45);
    }

    .play {
        position: absolute;
        top:50%;
        font-size: 24px;
        left:50%;
        transform: translate(-50%, -50%);
        color: #fff;
        /*background-color: rgba(0, 0, 0, 0.45);*/
    }


    .upload-img-5 {
        margin: 5px 0 90px 0;
    }

    .upload-img-1 {
        margin: 5px 0 15px 0;
    }
    .circle-div{
        text-align: center;
    }
    .circle-div>>>.van-circle__text{
        color: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// VideoUploader.vue?82a8f6e6